module.exports = __webpack_public_path__ + "static/media/brands-empty.1e592f74.svg";